import { render, staticRenderFns } from "./LargeLabels.vue?vue&type=template&id=ec6957d0&scoped=true"
import script from "./LargeLabels.vue?vue&type=script&lang=js"
export * from "./LargeLabels.vue?vue&type=script&lang=js"
import style0 from "./LargeLabels.vue?vue&type=style&index=0&id=ec6957d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6957d0",
  null
  
)

export default component.exports